export default function assertNever(x: never): never {
  throw new Error('[assertNever] Unexpected value: ' + x);
}
